var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallWhiteColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_71868",
    "data-name": "Path 71868",
    d: "M21,16.42v3.536a1,1,0,0,1-.93,1Q19.414,21,19,21A16,16,0,0,1,3,5q0-.414.046-1.07a1,1,0,0,1,1-.93H7.58a.5.5,0,0,1,.5.45q.035.344.065.552A13.9,13.9,0,0,0,9.349,8,.456.456,0,0,1,9.2,8.57L7.044,10.112a13.047,13.047,0,0,0,6.845,6.845L15.427,14.8A.462.462,0,0,1,16,14.653a13.9,13.9,0,0,0,4,1.205q.207.03.549.064A.5.5,0,0,1,21,16.42Z",
    transform: "translate(-3 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallWhiteColor);
export default __webpack_public_path__ + "static/media/call_white_color.84c14805c8c054f2a6b17895d9fc9473.svg";
export { ForwardRef as ReactComponent };